export const MAX_WAGE_WEEKLY = 10000
export const MAX_WAGE_YEARLY = 250000
